module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("批次号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.delivery_bn))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n                  社区店名称：" + _vm._s(_vm.detail.community_name) + "\n              ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n                  状态:\n                  "), (_vm.detail.status === 'PENDING') ? _c('el-tag', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.detail.status === 'SHIPPED') ? _c('el-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.detail.status === 'DONE') ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("已送达")]) : _vm._e(), _vm._v(" "), (_vm.detail.status === 'BADDONE') ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("已送达，有报损")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" 创建日期：" + _vm._s(_vm._f("datetime")(_vm.detail.created_time, 'yyyy-MM-dd hh:mm:ss')) + " ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" 发货时间："), (_vm.detail.shipped_time) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("datetime")(_vm.detail.shipped_time, 'yyyy-MM-dd hh:mm:ss')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" 签收时间: "), (_vm.detail.finish_time) ? _c('span', [_vm._v(_vm._s(_vm._f("datetime")(_vm.detail.finish_time, 'yyyy-MM-dd hh:mm:ss')))]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('span', [_vm._v(" 配送地址:")]), _c('span', [_vm._v(_vm._s(_vm.detail.address))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n                  备注：\n                  "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入备注"
    },
    on: {
      "blur": function($event) {
        return _vm.handleSetMemo()
      }
    },
    model: {
      value: (_vm.detail.memo),
      callback: function($$v) {
        _vm.$set(_vm.detail, "memo", $$v)
      },
      expression: "detail.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.detail.items,
      "border": "",
      "height": _vm.wheight - 270
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品图片",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": _vm.wximageurl + scope.row.item_pic,
            "width": "50"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "商品数量",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品编号",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_unit",
      "label": "单位",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bad_item_num",
      "label": "报损数量",
      "min-width": "100"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fe5beeb0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe5beeb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/deliverydetail.vue
// module id = 3004
// module chunks = 0